import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  localStorage: Storage;

  constructor() {
    this.localStorage = window.localStorage;
  }

  /**
   *
   * @param key localStorage entry name.
   * @returns localStorage entry.
   */
  get(key: string): any {
    if (this.isLocalStorageSupported && key) {
      // Convers to ASCII if base64.
      if (this.isBase64(this.localStorage.getItem(key))) {
        return JSON.parse(atob(this.localStorage.getItem(key)));
      } else {
        return JSON.parse(this.localStorage.getItem(key));
      }
    }
    return null;
  }

  /**
   * Creates a localStorage entry with given key and value arguments.
   * @param key localStorage entry name.
   * @param value data to be stored in localStorage.
   * @param encrypt setting true enables base64 encryption.
   * @returns true if localStorage is supported in browser.
   */
  set(key: string, value: any, encrypt: boolean = false): boolean {
    if (this.isLocalStorageSupported && (key || value)) {
      if (encrypt === true) {
        this.localStorage.setItem(key, btoa(JSON.stringify(value)));
      } else {
        this.localStorage.setItem(key, JSON.stringify(value));
      }
      return true;
    }
    return false;
  }

  /**
   *
   * @param key localStorage entry name.
   * @returns true if localStorage is supported in browser.
   */
  remove(key: string): boolean {
    if (this.isLocalStorageSupported && key) {
      this.localStorage.removeItem(key);
      return true;
    }
    return false;
  }

  /**
   * Removes all localStorage entries.
   */
  removeAll(): boolean {
    if (this.isLocalStorageSupported) {
      this.localStorage.clear();
      return true;
    }
    return false;
  }

  /**
   * Checks if an input value is base64.
   * @param str value to check if it is base64 encoded.
   * @returns true if value is base64 encoded.
   */
  isBase64(str) {
    try {
      return btoa(atob(str)) == str;
    } catch (err) {
      return false;
    }
  }

  /**
   * @returns true if browser supports localStorage
   */
  get isLocalStorageSupported(): boolean {
    return !!this.localStorage;
  }
}
